import React, {useState, useEffect} from 'react'
import Select from "react-select"
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';

import $ from 'jquery';

function TipoObjetoSelect(props) {

  const [loading, setloading] = useState(true);
  const [options, setoptions] = useState([]);

  const getData = () => {
    const url = `${API_URL}ParameterUX/TIPO-OBJETO-NOTIFICACION`;
    axios.get(url)
    .then(response => response.data)
    .then((data) => {
        // console.log('tipo objeto', data);
        let resData = data.result;
        let newItems = [];

        if(resData.length > 0){
          resData.map((item) => {
            let itemData = {};
            itemData.value = item.sClave;
            itemData.label = item.sValor;

            newItems.push(itemData);
          });
        }

        setoptions(newItems);
    })
    .catch(error => {
        console.log('Error de comunicación');
    });
  }

  useEffect(() => {
    if(loading){
      getData();
    }
  }, [])

  const changeSelect = (val) => {
    if(props.onChange){
      if(val !== null){
        props.onChange(val);
      }else{
        props.onChange(null);
      }
    }
  }
  
  return (
    <Select 
      isClearable
      options={[...options]}
      onChange={(val) => changeSelect(val)}
      value={props.value}
      placeholder="Tipo de objeto"
    />
  )
}

export default TipoObjetoSelect